<!-- eslint-disable vue/no-mutating-props -->
<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>
    <e-dialog
      :append-to-body="true"
      dialog-title="编辑商品"
      :center-dialog-visible.sync="itemDialogVisible"
      @resetPopupData="CancellHandle"
      @submitPopupData="submitPopupData"
    >
      <el-form label-width="80px" size="mini" :model="formData">
        <el-form-item label="商品名称">
          {{ itemDialogData.row && itemDialogData.row.name }}
        </el-form-item>
        <el-form-item label="商品图片">
          <div style="border: 1px solid #ccc; width: 102px; height: 102px">
            <img
              :src="itemDialogData.row && itemDialogData.row.imgUrl"
              :width="100"
              :height="100"
            />
          </div>
        </el-form-item>
        <el-form-item label="跳转类型:" prop="jumpType">
          <el-radio-group v-model="formData.jumpType" @input="jumpTypeChange">
            <el-radio label="2">跳转商品详情页</el-radio>
            <el-radio label="0">直接跳转</el-radio>
            <el-radio label="1">单点登录跳转</el-radio>
          </el-radio-group>
          <div class="tips">
            请确认目标链接已经完成单点登录集成，否则将可能影响跳转效果
          </div>
        </el-form-item>
        <el-form-item label="跳转链接:">
          <el-input
            v-model="formData.itemlinkUrl"
            :disabled="formData.jumpType == 2"
          />
        </el-form-item>
      </el-form>
    </e-dialog>
  </div>
</template>

<script>
import EDialog from '@/components/common/e-dialog.vue';
import { epecMallUrl } from '@/modules/projectA/api/config';

export default {
  //  let url = 'http://' + utils.getDomain(window.location.href); /* 获取主机地址和端口号 */
  // window.open(`${url}/products/productDetail?productId=${productId}&supplierId=${supplierId}`, '_blank');
  components: {
    EDialog,
  },
  props: {
    itemDialogVisible: {
      type: Boolean,
      default: false,
    },
    itemDialogData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      formData: {
        jumpType: '2',
        itemlinkUrl: this.getUrl(),
      },
    };
  },
  watch: {
    itemDialogVisible(val) {
      if (val) {
        this.formData.jumpType = this.itemDialogData.row.jumpType || '2';
        this.formData.itemlinkUrl =
          this.itemDialogData.row.itemlinkUrl || this.getUrl();
      }
    },
  },
  methods: {
    getUrl() {
      return `${epecMallUrl}/products/productDetail?productId=${
        this.itemDialogData &&
        this.itemDialogData.row &&
        this.itemDialogData.row.skuId
      }&supplierId=${
        this.itemDialogData &&
        this.itemDialogData.row &&
        this.itemDialogData.row.supplierCompanyId
      }`;
    },
    jumpTypeChange(val) {
      console.log(val);
      if (val == 2 || val == 1) {
        this.formData.itemlinkUrl = this.getUrl();
      }
    },
    CancellHandle() {
      this.$emit('update:itemDialogVisible', false);
    },
    submitPopupData() {
      this.$emit('submitPopupData', this.formData, this.itemDialogData);
      // this.$emit('update:itemDialogVisible', false);
      // console.log(this.formData,123123)
    },
  },
};
</script>

<style lang="scss" scoped></style>
